import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useApplicationFocus = (items, loading, setFilter) => {
  const location = useLocation();
  const targetId = new URLSearchParams(location.search).get('application');
  useEffect(() => { if (targetId) setFilter('all'); }, [targetId, location.key, setFilter]);
  useEffect(() => {
    if (!targetId || loading) return undefined;
    const timer = setTimeout(() => {
      const card = document.getElementById(`application-${targetId}`);
      card?.focus({ preventScroll: true });
      card?.scrollIntoView({ block: 'start', behavior: 'auto' });
    }, 80);
    return () => clearTimeout(timer);
  }, [targetId, location.key, loading, items]);
  return { targetId, navigationKey: location.key, missing: Boolean(targetId && !loading && !items.some((item) => item.id === targetId)) };
};